// extracted by css-extract-rspack-plugin
export default {"searchPrompt":"F0pwEQeHBMkbf4UT"};